/**
 * @generated SignedSource<<c776163f80bb7db17964fe0f34ed36ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisableModuleInput = {
  moduleId: string;
  datacenter?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type disableModuleMutation$variables = {
  input: DisableModuleInput;
};
export type disableModuleMutation$data = {
  readonly disableModule: {
    readonly deletedModuleId: string;
  } | null;
};
export type disableModuleMutation = {
  variables: disableModuleMutation$variables;
  response: disableModuleMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DisableModulePayload",
    "kind": "LinkedField",
    "name": "disableModule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedModuleId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "disableModuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "disableModuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3ec9238ceec9bce11857f02254f8ae39",
    "id": null,
    "metadata": {},
    "name": "disableModuleMutation",
    "operationKind": "mutation",
    "text": "mutation disableModuleMutation(\n  $input: DisableModuleInput!\n) {\n  disableModule(input: $input) {\n    deletedModuleId\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ee77a361b98cd13bd205f4e306e16b7";

export default node;
